import React from 'react';
import {Dialog, DialogActions, DialogContent, Button, TextField, Switch, Fab, Grid} from '@material-ui/core'
import ro from 'date-fns/locale/ro';
// import en from 'date-fns/locale/en';
import Calendar from 'react-calendar';
import SpecificComponent from '../SpecificComponent';


 

export default class AddProject extends SpecificComponent {
    constructor(props) {
      super(props);
       this.state = {
     
         }
    }

     componentDidMount(){
  
    }

   
     render() { 
       return (
          <div>
               <Dialog 
                 className="pm-alert-dialog"
                disableEscapeKeyDown
                fullWidth={true}
                maxWidth='md'
                 open={this.props.open}
                 onClose={this.props.dialogClose}>
                 <DialogActions >
                 <Fab  onClick={this.props.dialogClose} className="pm-round-button-dialog">
                                      <i className='material-icons pm-round-button-text-dialog'>close</i>
                            </Fab>
                 </DialogActions>
      
                
                    

                    <Grid  container  className="container pm-dialog-textfield-container" >
      
                            <Grid style={{textAlign:'center', marginBottom:20}} item xs={12} sm={12} md={12} lg={12} xl={12} >
                            <input className='pm-task-title-input'
                            style={{width:'70%', verticalAlign:'top', textAlign:'center'}} 
                            type='text' 
                            onFocus={this.props.focusName}
                            value={this.props.strNume} 
                            onChange={this.props.numeChange} 
                            onBlur={this.props.updateTaskTitle}/>
                            </Grid>

                            <Grid style={{textAlign:'center'}} item xs={12} sm={12} md={6} lg={6} xl={6} >
                              <span>{this.dictionary.proiecte.dateStart}</span>
                            <Calendar
                                            className='pm-calendar-projects'
                                            locale={this.props.limba.date}
                                            onChange={this.props.changeStartDate}
                                            value={this.props.startDate}
                                            />
                            </Grid>

                            <Grid style={{textAlign:'center'}} item xs={12} sm={12} md={6} lg={6} xl={6} >
                              <span>{this.dictionary.proiecte.dateFinish}</span>
                            <Calendar
                                            className='pm-calendar-projects'
                                            locale={this.props.limba.date}
                                            onChange={this.props.changeFinishDate}
                                            value={this.props.finishDate}
                                            />
                            </Grid>
                         
                    </Grid>        

                 <DialogActions className="pm-dialog-bottom-buttons">
                          
                          <Button  variant="outlined" onClick={this.props.addProject} className='pm-save-button'>
                                      {this.props.limba.comune.add}
                          </Button>

                         
                          
                       
                      </DialogActions>
                       
                   
                 </Dialog>
         </div>
        );
       }
}